
import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { LocalStorage } from 'ngx-store';
import { ToastrService } from 'ngx-toastr';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver';
import  *  as  helpData  from  '../../data/help/tasks.json';

//Model
import { FileExport } from '../../model/exporter.model';
import { ThemeSetting } from '../../model/users.model';
import { Task } from '../../model/tasks.model';
import { Url } from '../../model/users.model';

//Service
import { TaskService } from '../../services/tasks.service';
import { UsersService } from '../../services/users.service';
import { MaintenanceService } from '../../services/maintenance.service';
import { NonComplianceService } from '../../services/non-compliance.service';
import { IncidentsService } from '../../services/incidents.service';
import { DataService } from '../../services/data.service';
import { ExportService } from '../../services/exporter.service';

@Component({
    selector: 'app-tasks',
    templateUrl: './tasks.component.html',
    styleUrls: ['../datatable.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ TaskService , UsersService , MaintenanceService , IncidentsService]
  })
  
  export class TasksComponent implements OnInit {
    @LocalStorage() url: Url;
    @LocalStorage() themeSettings: ThemeSetting;
    rows = [];
    tasks = [];
    selected = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    public modalRef: NgbModalRef;
    isEditMode: boolean = false;

    public task: Task;
    public frmTask: FormGroup; 
    public categories: any[];
    public users: any[];
    public incidents: any[];
    public repairs: any[];
    public reports: any[];
    public tickets: any[];
    public ca_report: any[];
    public statuses: any[];

    public folderUserPath: string;
    public folderTaskPath: string;

    public prefixTask : string = 'tasks';
    help: any;
    count_tasks:number = 0;

    public exp_excel: FileExport;
    public exp_pdf: FileExport;
    spinner: boolean = false;
    
    //Stores the filtered and formatted content of the file
    formatted_list : any;

    @ViewChild('modalTask' ,{static: false}) modalTask: TemplateRef<any>;
    @ViewChild('modalDeleteTask', { static: false }) modalDeleteTask: TemplateRef<any>;
    
    constructor(private modal: NgbModal, 
                private _fb: FormBuilder, 
                private taskService: TaskService,
                private memberService: UsersService,
                private maintenanceService: MaintenanceService,
                private incidentService: IncidentsService,
                private data: DataService,
                private ncrService: NonComplianceService,
                private toastr: ToastrService,
                private exporter: ExportService
                ){
              
              this.folderUserPath = this.url.fileStorage + '/users/';console.log(this.folderUserPath);
              this.folderTaskPath = this.url.fileStorage + '/tasks/';
    }

    ngOnInit() {
      
      this.initTaskForm();
      
      this.getTasks();
      this.getMisc();
      this.exp_excel = {title:'', list_data:'', type:''};
      this.exp_pdf = {title:'', list_data:'', type:''};
      this.data.currentHelp.subscribe(help => this.help = help);
      setTimeout(() => { this.loadingIndicator = false; }, 1000);

    }

    ngAfterViewInit() {
      setTimeout(() => {  this.data.changeHelp(helpData["default"])});
    }

    public getMisc(){
      this.taskService.getTaskCategories().subscribe(data=>{
        this.categories = data["categories"];
      });

      this.memberService.getMembers().subscribe(data=>{
        this.users = data["members"];
      });

      this.incidentService.getIncidents().subscribe(data =>{
        this.incidents = data["incidents"];
      });

      this.maintenanceService.getDamageReports().subscribe(data =>{
        this.reports = data["damage_reports"];
      });

      this.maintenanceService.getRepairs().subscribe(data =>{
        this.repairs = data["repairs"];
      });

      this.incidentService.getTickets().subscribe(data =>{
        this.tickets = data["tickets"];
      });

      this.ncrService.getCARList().subscribe(data =>{
        this.ca_report = data["car"];
      });

      this.taskService.getTaskStatuses().subscribe(result => {
        this.statuses = result['statuses']
      })

    }

    public getTasks(){
      this.taskService.getTasks().subscribe(data =>{
        if (data["tasks"].length > 0){
          this.selected = [data["tasks"][0]];
          this.rows = data["tasks"];
          this.full_tasks_rows = data["tasks"];
          this.count_tasks = Object.keys(this.rows).length;
        } else {
          this.rows=[];
        }
            
      });
    }

    columns = [
          { prop: 'id' },
          { prop: 'title' },
          { prop: 'date_due' },
          { prop: 'created_by' },
          { prop: 'assigned_to' },
          { prop: 'percent_done' },
          { prop: 'task_category_id' },
          { prop: 'status_id' },
          { prop: 'report_id' },
          { prop: 'incident_id' },
          { prop: 'repair_request_id' },
          { prop: 'ticket_id' },
          { prop: 'ca_report_id' },
          { prop: 'is_urgent'},
          { prop: 'file'},
          { prop: 'notes'},
          { prop: 'create_by_name'},
          { prop: 'assigned_to_name'},
          { prop: 'created_by_avatar'},
          { prop: 'assigned_to_avatar'},
          { prop: 'created_at'},
          { prop: 'viewed_at'},
          { prop: 'updated_at'},
          { prop: 'category_name'},
          { prop: 'status_name'},
        ];

    onSelect({ selected }) {
      console.log('Select Event', selected, this.selected);
    }
  
    onActivate(event) {
      console.log('Activate Event', event);
      if (event.type === 'mouseenter') {
        // Code
          this.selected[0] = event.row;
        }
    }
    
    initTaskForm() {
      this.frmTask = this._fb.group({
        id                : [''],
        title             : ['', Validators.required],
        date_due          : [''],
        created_by        : [''],
        assigned_to       : ['', Validators.required],
        percent_done      : [0],
        task_category_id  : [1],
        status_id         : [1],
        report_id         : [''],
        incident_id       : [''],
        ca_report_id      : [''],
        repair_request_id : [''],
        ticket_id         : [''],
        is_urgent         : [0],
        file              : [''],
        notes             : [''],
        viewed_at         : ['0000-00-00 00:00:00'],

      });
    }


    openDeleteTaskModal(task: Task): void {
      
      if(task){
        this.task = task;
      } 
  
      this.modalRef = this.modal.open(this.modalDeleteTask, { size: 'sm', backdrop: 'static'});
      this.modalRef.result.then((result) => {
        this.frmTask.reset();
      }, (reason) => {
        this.frmTask.reset();
      });
    }   


    public createTask(task: Task) {
      this.taskService.createTask(task).subscribe(task => {
      this.getTasks();   
      });
    }

    async updateTask(task:Task) {
      console.log("UPDATE TASK");
      this.spinner = true;
      await this.taskService.updateTask(task).toPromise().then(task => {
        this.getTasks();  
      });
      console.log('updated Task');
      this.spinner = false;
    }

    async deleteTask(id: number) {
      console.log("DELETE TASK");
      this.spinner = true;
      await this.taskService.deleteTask(id).toPromise().then(task => {
        this.toastr.success('', task["message"], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
        this.getTasks();   
      }).catch(err =>{
        this.toastr.error("Please try again.", "There was a problem with deleting the selected task", {
          timeOut: 4000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      });
      this.closeModal();  
      this.spinner = false;
    }


    public onSubmitTask(task: Task):void {
      this.task = task;
      if (this.frmTask.valid) {
        this.task= task;
        
        if(task.id){
          this.updateTask(this.task);
          console.log('updating task...');
        }
        else{
          
          console.log('creating task...');
          console.log(task);
          this.taskService.createTask(task).subscribe(task => {
            this.getTasks();
            });
        }   
        this.getTasks();
        this.closeModal();   
       
      }
    }
  
    public closeModal(){
      this.modalRef.close();
      this.task = null;
      this.getTasks();
    }

    print(): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
          <html>
          <head>
          <title>Task List</title>
          <style>
          @page {
            size: A4;
          }

          table {
            border-collapse: collapse;
            border-spacing: 0;
            width: 100%;
            border: 1px solid #ddd !important;
        }

        th, td {
            text-align: left;
            padding: 16px;
        }


        tr:nth-child(even) {
            background-color: #f2f2f2 !important;
            box-shadow: inset 0 0 0 1000px #f2f2f2;
        }

        .fn {
          float: footnote;
        }

        thead {
          box-shadow: inset 0 0 0 1000px #f2f2f2;
        }
          
            
        </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
          </html>`
        );
        popupWin.document.close();
    }

    public formatDate(inDate: string) {
      let formatedDate: Date;
      formatedDate = new Date(inDate.replace(/-/g, "/"));
      return formatedDate;
    }


    openPromptModalTask(modalName, task:Task) { 

    if(task){
      this.isEditMode = true;
      this.task = task;
    }else{
      this.isEditMode = false;  
    };

    this.modalRef = this.modal.open(modalName, { size: 'lg', backdrop: 'static'});
  }  

  getCellClass({ row, column, value }): any {
    return {
      'is-pending': row.status_id == '1',
      'is-completed': row.status_id == '3',
      'is-processing': row.status_id == '2',
      //'is-cancelled': row.status_id == '4'
    };
  }

  //filtering 
  showFilters: boolean = false;
  isFilterEmpty: boolean = true;

  filter_assigned_to: string ='';
  filter_title: string ='';
  filter_category: string ='';
  filter_due_fr: Date;
  filter_due_to: Date;
  filter_status: string = '';
  

  temp_tasks = [];
  full_tasks_rows = [];
  

  //show_created_by : boolean = true;   
  public show_assigned_to : boolean = true;  
  public show_title : boolean = true;
  public show_category : boolean = true;   
  public show_status : boolean = true;   
  public show_date_due : boolean = true;   
  public show_notes : boolean = false;   
  public show_percent_done : boolean = true;   
  public show_created_date : boolean = false;
  public show_updated_date : boolean = false;
  public show_viewed_date : boolean = false;
  public show_file : boolean = false;
  
  public toggleFilters() {
    if (this.showFilters) this.showFilters = false;
    else this.showFilters = true;
  }

  updateFilter() {
    this.isFilterEmpty = false;

    this.temp_tasks = this.full_tasks_rows.filter(data => {
      if (this.filter_assigned_to && data.assigned_to_name){
        return data.assigned_to_name.toLowerCase().indexOf(this.filter_assigned_to.toLowerCase()) !== -1 || !this.filter_assigned_to.toLowerCase();    
      }else{
        return data.assigned_to_name;
      }
    });

    this.temp_tasks = this.temp_tasks.filter(data => {
      if (this.filter_category && data.task_category_id){
        return data.category_name.toLowerCase().indexOf(this.filter_category.toLowerCase()) !== -1 || !this.filter_category.toLowerCase();    
      }else{
        return data.category_name;
      }
    });

    this.temp_tasks = this.temp_tasks.filter(data => {
      if (this.filter_title && data.title){
        return data.title.toLowerCase().indexOf(this.filter_title.toLowerCase()) !== -1 || !this.filter_title.toLowerCase();    
      }else{
        return data.title;
      }
    });

    this.temp_tasks = this.temp_tasks.filter(data => {
      if (this.filter_status && data.status_name){
        return data.status_name.toLowerCase().indexOf(this.filter_status.toLowerCase()) !== -1 || !this.filter_status.toLowerCase();    
      }else{
        return data.status_name;
      }
    });

    this.temp_tasks = this.temp_tasks.filter(data => { 
      if (data.date_due && (this.filter_due_fr && this.filter_due_to)){
        return ( new Date(data.date_due) >= new Date(this.filter_due_fr) && new Date(data.date_due) <= new Date(this.filter_due_to));   
      }else{
        return data.date_due;
      };
    });
    
    this.rows = this.temp_tasks;
    this.count_tasks = Object.keys(this.temp_tasks).length;
    
  }

  public resetFilters() {
    this.filter_assigned_to = '';
    this.filter_due_fr = null;
    this.filter_due_to = null;
    this.filter_category = '';
    this.filter_status = '';
    this.filter_title = '';

    this.rows = this.full_tasks_rows;
    this.count_tasks = Object.keys(this.rows).length;
    
    this.isFilterEmpty = true;

  }


//Replaces an attribute name for reading comprehension
renameKey( obj, oldKey, newKey ) {
  obj[newKey] = obj[oldKey];
delete obj[oldKey];


}

 //Formats readable header names in the given table
generateHeaders(task): any{
  const arr = JSON.parse(task);
  arr.forEach( obj => {
this.renameKey( obj, 'assigned_to_name', 'Assigned To' );
this.renameKey( obj, 'title', 'Title' );
this.renameKey( obj, 'category_name', 'Category' );
this.renameKey( obj, 'status_name', 'Status' );
this.renameKey( obj, 'file', 'File' );
this.renameKey( obj, 'notes', 'Notes' );
this.renameKey( obj, 'date_due', 'Date Due' );
this.renameKey( obj, 'percent_done', 'Percentage Done' );
this.renameKey( obj, 'created_at', 'Created Date' );
this.renameKey( obj, 'viewed_at', 'Last Viewed Date' );
this.renameKey( obj, 'updated_at', 'Last Updated Date' );
  });
  const updatedJson = JSON.stringify( arr );
  return updatedJson;
}

//Filters every column in the table list
generateColumnsWithFilter(task){
  const arr = JSON.parse(JSON.stringify(task));
  arr.forEach( obj => {
    
  //format date
  obj['date_due'] = formatDate(obj['date_due'], 'dd MMM yyyy', 'en_US');
  
//remove filtered columns
if(!this.show_assigned_to){
  delete obj['assigned_to_name'];
};
if(!this.show_title){
  delete obj['title'];
};
if(!this.show_category){
  delete obj['category_name'];
};
if(!this.show_file){
  delete obj['file'];
};
if(!this.show_notes){
  delete obj['notes'];
};
if(!this.show_status){
  delete obj['status_name'];
};
if(!this.show_date_due){
  delete obj['date_due'];
};
if(!this.show_percent_done){
  delete obj['percent_done'];
};
if(!this.show_created_date){
  delete obj['created_at'];
};
if(!this.show_viewed_date){
  delete obj['viewed_at'];
};
if(!this.show_updated_date){
  delete obj['updated_at'];
};

delete obj['ca_report_problem']
delete obj['id'];
delete obj['created_by'];
delete obj['assigned_to'];
delete obj['is_urgent'];
delete obj['task_category_id'];
delete obj['status_id'];
delete obj['incident_description'];
delete obj['report_description'];
delete obj['repair_description'];
delete obj['ticket_description'];
delete obj['assigned_to_avatar'];
delete obj['created_by_name'];
delete obj['created_by_avatar'];
  });
  const updatedJson = JSON.stringify( arr );
  return updatedJson;                         
}

//Exports table to CSV file
exportToCSV(){
  if(this.rows.length >0){
      let with_header_format, with_column_filter;
      
      //generate json with filtered column
      with_column_filter = this.generateColumnsWithFilter(this.rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let csv_file = '[TMS]Task_' + this.formattedDate(current_date);
      this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Task');
  }
};

//Exports table to PDF file
exportToPDF(){
  if(this.rows.length >0){
    let with_header_format, with_column_filter;

    //generate json with filtered column
    with_column_filter = this.generateColumnsWithFilter(this.rows);

    //generate json with format header
    this.formatted_list = this.generateHeaders(with_column_filter);

    //export to file
    let current_date = new Date();
    let pdf_file = '[TMS]Task' + this.formattedDate(current_date);
    this.exp_pdf.title = 'Task';
    this.exp_pdf.type = 'pdf';
    this.exp_pdf.list_data = this.formatted_list;
    this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
      saveAs(data, pdf_file + '.' + this.exp_pdf.type);
    });
  }
};

//Exports table to MS Excel file
exportToExcel(){
  if(this.rows.length >0){
      let with_header_format, with_column_filter;
      
      //generate json with filtered column
      with_column_filter = this.generateColumnsWithFilter(this.rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let excel_file = '[TMS]Task_' + this.formattedDate(current_date);
      this.exp_excel.title = 'Task';
      this.exp_excel.type = 'xlsx';
      this.exp_excel.list_data = this.formatted_list;
      this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
          
          saveAs(data, excel_file)

      });
  }
}; 

//Returns a date format in the file name
public formattedDate(d = new Date) {
let month = String(d.getMonth() + 1);
let day = String(d.getDate());
const year = String(d.getFullYear());

if (month.length < 2) month = '0' + month;
if (day.length < 2) day = '0' + day;

return `${day}/${month}/${year}`;
}

}